import * as React from "react";
import { connect } from "react-redux";
import { withRouter, Redirect, RouteComponentProps } from "react-router-dom";

import { ROUTES } from "@config/soft.routing";

import { AUTH_REDIRECTS } from "@typings/globals";

import {
  isUserLoggedIn,
  isUserAdmin,
  isUserStateKnown,
} from "@soft/redux/user/user.selectors";
import { IStore } from "@soft/redux/reducers";

interface Props extends RouteComponentProps {
  asAdminOnly?: boolean;
  children: React.ReactNode;
  isUserAdmin: boolean;
  isUserLoggedIn: boolean;
  isUserStateKnown: boolean;
  redirect?: ROUTES;
}

export const AuthGuardContainer = withRouter((props: Props) => {
  const { search } = props.location;

  const toObject = (pathname: string | ROUTES) => ({
    pathname,
    search,
    state: {
      referer: props.history.location.pathname,
      reason: AUTH_REDIRECTS.UNAUTHENTICATED,
      originalRoute: props.redirect ? props.location.pathname : undefined,
    },
  });

  if (!props.isUserStateKnown) {
    return null;
  }

  const isAuthenticated = Boolean(
    props.asAdminOnly
      ? props.isUserLoggedIn && props.isUserAdmin
      : props.isUserLoggedIn,
  );

  if (isAuthenticated) {
    return <React.Fragment>{props.children}</React.Fragment>;
  }

  if (props.redirect) {
    return <Redirect push={false} to={toObject(props.redirect)} />;
  }

  return <Redirect push={false} to={toObject(ROUTES.NOT_FOUND)} />;
});

const mapState = (store: IStore) => ({
  isUserAdmin: isUserAdmin(store),
  isUserLoggedIn: isUserLoggedIn(store),
  isUserStateKnown: isUserStateKnown(store),
});

export const AuthGuard = connect(mapState)(AuthGuardContainer);

AuthGuard.displayName = "AuthGuard";
